import { jsx as _jsx } from "react/jsx-runtime";
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { RouterSelectSingle // @ts-expect-error Could not find a declaration file for module
} from '../../../containers/TracksPage/RouterDropdownFilter';
import { FormattedMessage } from '../../../components/I18n';
import styled from '../../../utils/Styling';
const RouterSelectSingleStyled = styled(RouterSelectSingle).withConfig({
  displayName: "PlaylistAssignmentsAssignedByFilter__RouterSelectSingleStyled",
  componentId: "sc-17f0b42-0"
})(["&&{padding:0 !important;}"]);

const PlaylistAssignmentsAssignedByFilter = () => {
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.assignedBy.filterTitle"
      }),
      children: /*#__PURE__*/_jsx(RouterSelectSingleStyled, {
        filterType: "assignedBy",
        menuWidth: 170
      })
    })
  });
};

export default PlaylistAssignmentsAssignedByFilter;